<p-panel
  [toggleable]="true"
  [(collapsed)]="collapsed"
  styleClass="mb-6"
>
  <ng-template #header>
    <div class="flex items-center gap-2">
      <i class="fa-solid fa-filter text-sm"></i>
      <span class="font-semibold">{{ 'common.filters' | translate }}</span>
      @if (hasActiveFilters()) {
        <span class="inline-flex items-center justify-center w-5 h-5 rounded-full bg-primary text-primary-contrast text-xs font-bold leading-none">
          {{ activeFilterCount() }}
        </span>
      }
    </div>
  </ng-template>

  <div class="flex flex-wrap gap-x-4 gap-y-4 items-end">

    @for (filter of filters(); track filter.name) {
      <div class="flex flex-col gap-1.5 min-w-48"
        [pTooltip]="filter.disabled && filter.disabledTooltip ? (filter.disabledTooltip | translate) : null"
        tooltipPosition="top"
      >
        <label class="text-xs font-medium uppercase tracking-wide"
          [class.text-muted]="!filter.disabled"
          [class.text-muted/40]="filter.disabled"
        >
          {{ filter.label | translate }}
        </label>

        @switch (filter.type) {
          @case ('text') {
            <input
              pInputText
              type="text"
              [ngModel]="values[filter.name]"
              (ngModelChange)="values[filter.name] = $event"
              (keyup.enter)="onSearch()"
              [placeholder]="filter.label | translate"
              [disabled]="filter.disabled ?? false"
              class="w-full"
            />
          }
          @case ('select') {
            <p-select
              [options]="resolvedOptions[filter.name] ?? []"
              [ngModel]="values[filter.name]"
              (ngModelChange)="values[filter.name] = $event"
              optionLabel="label"
              optionValue="value"
              [placeholder]="'common.all' | translate"
              [showClear]="true"
              [disabled]="filter.disabled ?? false"
              appendTo="body"
              styleClass="w-full"
            />
          }
          @case ('boolean') {
            <p-select
              [options]="[{ label: ('common.yes' | translate), value: true }, { label: ('common.no' | translate), value: false }]"
              [ngModel]="values[filter.name]"
              (ngModelChange)="values[filter.name] = $event"
              optionLabel="label"
              optionValue="value"
              [placeholder]="'common.all' | translate"
              [showClear]="true"
              [disabled]="filter.disabled ?? false"
              appendTo="body"
              styleClass="w-full"
            />
          }
          @case ('objectId') {
            @if (filter.options?.length) {
              <p-select
                [options]="filter.options"
                [ngModel]="values[filter.name]"
                (ngModelChange)="values[filter.name] = $event"
                optionLabel="label"
                optionValue="value"
                [placeholder]="'common.all' | translate"
                [showClear]="true"
                [disabled]="filter.disabled ?? false"
                appendTo="body"
                styleClass="w-full"
              />
            } @else {
              <input
                pInputText
                type="text"
                [ngModel]="values[filter.name]"
                (ngModelChange)="values[filter.name] = $event"
                (keyup.enter)="onSearch()"
                [placeholder]="filter.label | translate"
                [disabled]="filter.disabled ?? false"
                class="w-full"
              />
            }
          }
          @case ('dateRange') {
            <p-datepicker
              [ngModel]="values[filter.name]"
              (ngModelChange)="values[filter.name] = $event"
              selectionMode="range"
              [readonlyInput]="true"
              [showIcon]="true"
              [disabled]="filter.disabled ?? false"
              appendTo="body"
              styleClass="w-full"
            />
          }
        }
      </div>
    }

    <!-- Action buttons -->
    <div class="flex gap-2 ml-auto self-end">
      <button
        pButton
        type="button"
        severity="secondary"
        [outlined]="true"
        icon="fa-solid fa-rotate-right"
        [label]="'button.reset' | translate"
        (click)="onReset()"
      ></button>
      <button
        pButton
        type="button"
        icon="fa-solid fa-magnifying-glass"
        [label]="'button.search' | translate"
        (click)="onSearch()"
      ></button>
    </div>

  </div>
</p-panel>
